import http from './http-common';

class crudService {

    list(path, params) {
        return http.list(path, params)
    }

    get(path) {
        return http.get(path)
    }

    getAll(path, page, params) {

        return http.getAll(path, page, params)
    }

    getResume(path, type, param, allStatus = false) {
        return http.getResume(path, type, param, allStatus);
    }

    getById(path, id, forceReadById = false) {
        return http.getById(path, id, forceReadById)
    }

    getAssemble(path, type = '', params) {
        return http.getAssemble(path, type, params)
    }

    create(path, data) {
        return http.post(path, data)
    }

    update(path, data) {
        return http.put(path, data)
    }

    save(path, command, data) {
        if (command === 'insert') {
            return this.create(path, data)
        } else {
            return this.update(path, data)
        }
    }

    remove(path, id) {
        return http.remove(path, id)
    }

    delete(path) {
        return http.removeByPath(path)
    }


}

export default new crudService();
